
import { computed, defineComponent, reactive, ref, toRefs, watch, ComputedRef } from 'vue'
import jfshool from '@/api/jfschool'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import router from '@/router/index'
import { PlayCircleFilled } from '@ant-design/icons-vue'
import Card from './card.vue'
export default defineComponent({
  components: {
    PlayCircleFilled,
    Card
  },
  setup() {
    type pageDataType = {
      list: Array<any>
      total: number
      theme: string
      loading: boolean
      groupName: ComputedRef<string> | string
    }
    const route = useRoute()
    const pageData: pageDataType = reactive({
      list: [],
      total: 0,
      theme: (route.query.theme as string) || 'light',
      loading: false,
      groupName: route.query.groupName as string
    })
    pageData.groupName = computed(() => {
      return route.query.groupName as string
    })
    const store = useStore()
    function getlist() {
      pageData.loading = true
      const data: any = {}
      data.data = {
        groupCode: route.query.groupCode
      }
      const _signature: any = []
      for (const key in data.data) {
        _signature.push(data.data[key])
      }
      const _time: any = '' + parseInt((new Date().getTime() / 1000) as any) * 1000
      data.headers = {
        token: route.query.token,
        // clienttype: 'pc',
        // appVersion: store.state.pcqueryInfo.appversion,
        appcode: store.state.pcqueryInfo.appcode,
        serverId: store.state.pcqueryInfo.serverid,
        timestamp: _time,
        signature: window.Md5.hashStr('sjdxfnqogbzoun13d971ckh8p' + _signature.join('') + _time)
      }
      jfshool.getCourse(data).then((res: any) => {
        const result = res.data
        res.data.forEach(item => {
          item.lessonName = item.chapterName || item.lessonName
        })
        pageData.list = result
        pageData.loading = false
      })
    }
    getlist()
    function gotoCourseDetail(p: { courseNo: any; lessonNo: number | string }) {
      const query = JSON.parse(JSON.stringify(route.query))
      delete query.groupCode
      router.push({
        name: 'coursedetail',
        query: {
          ...query,
          courseNo: p.courseNo,
          lessonNo: p.lessonNo
        },
        params: {
          groupName: route.query.groupName as string
        }
      })
    }
    function getName(course: any) {
      let name = course.courseName
      if (route.query.softNameAbbr === 'jfzt') {
        // 旗舰
        name = course.chapterName || name
      } else if (route.query.softNameAbbr === 'jfztADV') {
        // 擒龙
        name = course.lessonName || name
      }
      return name
    }
    watch(
      () => route.query.theme,
      (val: any) => {
        pageData.theme = val as string
      }
    )
    watch(
      () => route.query.groupCode,
      (val: any) => {
        if (val) {
          getlist()
        }
      }
    )
    return {
      ...toRefs(pageData),
      gotoCourseDetail,
      getName
    }
  }
})
